import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyNote, HttpResponse } from "@/types";

export function useGetCompanyNotes() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["company-notes", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/company-notes`;
      const res = await guacHttpClient.get<
        CompanyNote[],
        HttpResponse<CompanyNote[]>
      >(path);
      return res.data;
    },
  });
}
